import { Tag, Tooltip } from 'antd'
import { FC } from 'react'
import Shipment from '../../../../../types/api/shipment'
import { getShipmentCuratorInfo } from '../../../../../helpers/entities/shipment/curator-approval'

interface Props {
    shipment?: Shipment
}

const CuratorPrintTag: FC<Props> = ({ shipment }) => {
    if (!shipment?.printWithCurator) return null

    return (
        <Tooltip title={getShipmentCuratorInfo(shipment)}>
            <Tag color='purple' bordered={false}>
                К
            </Tag>
        </Tooltip>
    )
}

export default CuratorPrintTag
